import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import useNotifications from '../../hooks/useNotifications'
import { getFrontendBaseUrl, addUrlQueryParams } from '../../util/UrlUtil'

export default () => {}

export function useQueues() {
  const { t } = useTranslation()
  const [queuesData, setQueuesData] = useState({})
  const notifications = useNotifications()

  function openUrlInNewTab(currentWindow, path, tabType) {
    const url = getFrontendBaseUrl() + path
    currentWindow.open(url, tabType)
  }

  function openUrlInYadVashemTab(currentWindow, url) {
    try {
      currentWindow = initializeYadVashemTabIfNecessary(currentWindow)
      currentWindow.yadVashemTab.location.href = url
      currentWindow.yadVashemTab.focus()
    } catch (err) {
      notifications.error(
        t(
          'queues.error.yadvashem',
          'Unable to update Yad Vashem Tab probably because the tab that opened the Yad Vashem tab in the first place has been Closed. Please close the Yad Vashem tab and try again'
        ),
        err
      )
    }
  }

  function goToUrlAndAppendYadVashemTab(currentWindow, path, tabType) {
    currentWindow = initializeYadVashemTabIfNecessary(currentWindow)
    const url = getFrontendBaseUrl() + path
    const tab = currentWindow.open(url, tabType)
    if (tab) {
      tab.yadVashemTab = currentWindow.yadVashemTab
    }
  }

  function initializeYadVashemTabIfNecessary(currentWindow) {
    if (!currentWindow.yadVashemTab || currentWindow.yadVashemTab.closed) {
      currentWindow.yadVashemTab = currentWindow.open(
        'https://collections.yadvashem.org/en/names/search-results?',
        'thisIsTheYadVashemTab'
      )
    }
    return currentWindow
  }

  async function queueButtonYadVashem(person) {
    const firstName = person?.nameParts?.find((part) => part.type === 'http://gedcomx.org/Given')?.value
    const lastName = person?.nameParts?.find((part) => part.type === 'http://gedcomx.org/Surname')?.value
    const birthYear =
      person?.birth?.value?.date?.normalized?.[0]?.value?.match(/\d{4}/)?.[0] ||
      person?.birth?.value?.date?.original?.match(/\d{4}/)?.[0] ||
      '' // four digits is a year

    const params = {
      s_year_birth_search: birthYear,
    }

    if (firstName !== undefined) {
      params.s_first_name_search_en = firstName
      params.t_first_name_search_en = 'yvSynonym'
    }

    if (lastName !== undefined) {
      params.s_last_name_search_en = lastName
      params.t_last_name_search_en = 'yvSynonym'
    }

    const url = addUrlQueryParams('https://collections.yadvashem.org/en/names/search-results', params)
    openUrlInYadVashemTab(window, url)
    return url
  }

  return {
    openUrlInNewTab,
    openUrlInYadVashemTab,
    goToUrlAndAppendYadVashemTab,
    initializeYadVashemTabIfNecessary,
    queueButtonYadVashem,
    queuesData,
    setQueuesData,
  }
}
